import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { cn } from "@/utils/cn";
function TooltipProvider({ delayDuration = 0, ...props }) {
    return React.createElement(TooltipPrimitive.Provider, { "data-slot": "tooltip-provider", delayDuration: delayDuration, ...props });
}
function Tooltip({ ...props }) {
    return (React.createElement(TooltipProvider, null,
        React.createElement(TooltipPrimitive.Root, { "data-slot": "tooltip", ...props })));
}
function TooltipTrigger({ ...props }) {
    return React.createElement(TooltipPrimitive.Trigger, { "data-slot": "tooltip-trigger", ...props });
}
function TooltipContent({ className, sideOffset = 0, children, ...props }) {
    return (React.createElement(TooltipPrimitive.Portal, null,
        React.createElement(TooltipPrimitive.Content, { "data-slot": "tooltip-content", sideOffset: sideOffset, className: cn("bg-white text-black border animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-[200] w-fit origin-(--radix-tooltip-content-transform-origin) rounded-md px-3 py-1.5 text-xs text-balance", className), ...props },
            children,
            React.createElement(TooltipPrimitive.Arrow, { className: "bg-white border-r border-b fill-white z-[100] size-2.5 translate-y-[calc(-50%_-_1px)] rotate-45 rounded-[2px]" }))));
}
export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
